import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Download, FolderOpen, Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api, downloadFile, errMsg, fmtDateTime } from '../api';
import { Card, Empty, SectionTitle } from '../ui';

export const downloadDossier = (d) => downloadFile(`/dossier/${d.id}/pdf`, `BOND_dossier_${d.title.replace(/[^A-Za-z0-9]+/g, '_')}.pdf`);

function Row({ d, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const pdf = async () => {
    setBusy(true);
    try { await downloadDossier(d); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const del = async () => {
    try { await api.delete(`/dossier/${d.id}`); onDeleted(d.id); } catch (e) { toast.error(errMsg(e)); }
  };
  const parts = [[d.report_ids.length, 'report'], [d.aml_ids.length, 'AML'], [d.property_ids.length, 'immobili'], [(d.negative_ids || []).length, 'negatività']].filter(([n]) => n).map(([n, l]) => `${n} ${l}`);
  return (
    <div className="px-6 py-4 flex flex-wrap items-center gap-4" data-testid={`dossier-row-${d.id}`}>
      <div className="flex-1 min-w-0">
        <p className="text-sm truncate">{d.title}</p>
        {d.pending && <p className="text-xs text-[#D9822B] mt-0.5" data-testid={`dossier-pending-${d.id}`}>Reputational check in corso o soggetto da confermare: il PDF sarà disponibile al termine. <Link to={`/portal/reputational/${d.pending_check_id}`} className="underline">Apri verifica</Link></p>}
        <p className="text-xs font-mono text-[#5A5F67]">{fmtDateTime(d.created_at)} · {parts.join(' · ')}{d.company_graph && d.report_ids.length ? ' · grafo aziendale' : ''}{d.aml_graph && d.aml_ids.length ? ' · grafo AML' : ''}</p>
      </div>
      <button onClick={pdf} disabled={busy || d.pending} className="h-9 px-3 text-xs flex items-center gap-2 border border-[#1F242C] hover:border-[#D4AF37] transition-colors disabled:opacity-40" data-testid={`dossier-pdf-${d.id}`}>
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}Scarica PDF
      </button>
      <button onClick={del} className="h-9 w-9 flex items-center justify-center text-[#5A5F67] hover:text-[#E37A72] transition-colors" data-testid={`dossier-delete-${d.id}`} aria-label="Elimina dossier"><Trash2 size={14} /></button>
    </div>
  );
}

export default function DossierList({ items, setItems }) {
  return (
    <Card>
      <div className="p-6 pb-2"><SectionTitle>Dossier creati</SectionTitle></div>
      {items && !items.length && <Empty icon={FolderOpen} title="Nessun dossier ancora" text="I dossier che crei compaiono qui e puoi riscaricarli quando vuoi, gratuitamente." />}
      <div className="divide-y divide-[#1F242C]" data-testid="dossier-list">
        {(items || []).map((d) => <Row key={d.id} d={d} onDeleted={(id) => setItems((l) => l.filter((x) => x.id !== id))} />)}
      </div>
    </Card>
  );
}
